// extracted by mini-css-extract-plugin
module.exports = {"exception":"exception-041e295d","imgBlock":"imgBlock-f3c93db6","imgEle":"imgEle-ca9734b8","content":"content-4f524f32","desc":"desc-0ad44fa3","actions":"actions-1249dc4d"};